/**
 * AdminOnlyRoute — guard chroniący ścieżkę dostępną wyłącznie dla adminów.
 *
 * Reuse `useIsAdmin` (endpoint backendowy `/creator-lock/diagnostics` z
 * `_require_admin`). Non-admin dostaje redirect na `/dashboard`. Podczas
 * fetchu (`null`) renderujemy `null` — brak flashu chronionej strony.
 *
 * Rzetelną weryfikację i tak wykonuje backend (endpointy administracyjne
 * mają własne `_require_admin`). Ten komponent tylko:
 *  1. blokuje bezpośredni URL non-adminom,
 *  2. eliminuje mylący render strony z „broken" akcjami.
 */
import { Navigate } from "react-router-dom";
import { useIsAdmin } from "@/hooks/useIsAdmin";

const AdminOnlyRoute = ({ children }) => {
  const isAdmin = useIsAdmin();
  if (isAdmin === null) return null;           // pending — nic nie renderuj
  if (isAdmin === false) return <Navigate to="/dashboard" replace />;
  return children;
};

export default AdminOnlyRoute;
